// extracted by mini-css-extract-plugin
module.exports = {"editable":"inline-input_editable__3ta9w","static":"inline-input_static__3KGU_"};